import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Stack } from '@mui/material';

import StatusIcon from '../../../assets/icons/StatusIconInFilters.svg';
import LabeledField from '../../../components/LabeledField';
import { SelectDropdownFilter } from '../../../components/SelectDropdownFilter/SelectDropdownFilter';

const optionShape = PropTypes.shape({
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

const TimekeepingStatusTagsFilters = ({
  isTimecardsLoading,
  statusOptions,
  tagOptions,
  initialStatus,
  initialTags,
  handleStatusChange,
  handleTagsChange,
}) => (
  <Stack gap="12px" mb="24px">
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
      <Box>
        <LabeledField
          title={LanguageConverterV2('timekeeping.filter.status')}
          field={
            <SelectDropdownFilter
              disabled={isTimecardsLoading}
              placeholder={LanguageConverterV2('timekeeping.filter.status')}
              isMultiSelectable
              onValueChange={handleStatusChange}
              options={statusOptions}
              getOptionLabel={(option) => option.name}
              wrapperSx={{ width: '350px' }}
              startAdornmentIcon={
                <Box
                  component="img"
                  sx={{ height: 16, width: 16 }}
                  alt={LanguageConverterV2('timekeeping.filter.status')}
                  src={StatusIcon}
                />
              }
              initialValue={initialStatus}
            />
          }
        />
      </Box>
      <Box>
        <LabeledField
          title={LanguageConverterV2('timekeeping.filter.tags')}
          field={
            <SelectDropdownFilter
              disabled={isTimecardsLoading}
              isMultiSelectable
              placeholder={LanguageConverterV2('timekeeping.filter.tags')}
              onValueChange={handleTagsChange}
              options={tagOptions}
              getOptionLabel={(option) => option.name}
              startAdornmentIcon={
                <Box
                  component="img"
                  sx={{ height: 16, width: 16 }}
                  alt={LanguageConverterV2('timekeeping.filter.tags')}
                  src={StatusIcon}
                />
              }
              wrapperSx={{ width: '350px' }}
              initialValue={initialTags}
            />
          }
        />
      </Box>
    </Box>
  </Stack>
);

export default TimekeepingStatusTagsFilters;

TimekeepingStatusTagsFilters.propTypes = {
  isTimecardsLoading: PropTypes.bool,
  statusOptions: PropTypes.arrayOf(optionShape).isRequired,
  tagOptions: PropTypes.arrayOf(optionShape).isRequired,
  initialStatus: PropTypes.arrayOf(optionShape),
  initialTags: PropTypes.arrayOf(optionShape),
  handleStatusChange: PropTypes.func.isRequired,
  handleTagsChange: PropTypes.func.isRequired,
};

TimekeepingStatusTagsFilters.defaultProps = {
  isTimecardsLoading: false,
  initialStatus: [],
  initialTags: [],
};
